import { createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/images/chat/messenger-inactive.svg'
import _imports_1 from '../../assets/images/chat/messenger-active.svg'
import _imports_2 from '../../assets/images/chat/phone-inactive.svg'
import _imports_3 from '../../assets/images/chat/phone-active.svg'
import _imports_4 from '../../assets/images/chat/calendar-inactive.svg'
import _imports_5 from '../../assets/images/chat/calendar-active.svg'
import _imports_6 from '../../assets/images/chat/family-portal-icon.svg'


const _hoisted_1 = { id: "Message_Center" }
const _hoisted_2 = {
  class: "row mx-0 h-100",
  id: "MessageCenter__List"
}
const _hoisted_3 = { class: "nav list-group list-group-flush" }
const _hoisted_4 = { class: "d-flex flex-column align-items-center pt-1 px-1 h-100" }
const _hoisted_5 = { src: _imports_0 }
const _hoisted_6 = { src: _imports_1 }
const _hoisted_7 = { class: "unread-message-badge" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-primary px-1"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", { class: "fw-normal" }, "Chat")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "d-flex flex-column align-items-center pt-1 px-1 h-100" }
const _hoisted_11 = { src: _imports_2 }
const _hoisted_12 = { src: _imports_3 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", { class: "fw-normal" }, "Calls")
], -1 /* HOISTED */)
const _hoisted_14 = { class: "d-flex flex-column align-items-center pt-1 px-1 h-100" }
const _hoisted_15 = { src: _imports_4 }
const _hoisted_16 = { src: _imports_5 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", { class: "fw-normal" }, "Calendar")
], -1 /* HOISTED */)
const _hoisted_18 = { class: "d-flex flex-column align-items-center pt-1 px-1 h-100" }
const _hoisted_19 = {
  class: "family-portal-icon",
  src: _imports_6
}
const _hoisted_20 = {
  class: "family-portal-icon",
  src: _imports_6
}
const _hoisted_21 = { class: "unread-thread-badge" }
const _hoisted_22 = {
  key: 0,
  class: "badge bg-primary px-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", { class: "fw-normal" }, [
    /*#__PURE__*/_createTextVNode("Family "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Portal")
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { class: "col px-0 h-100 overflow-auto chat-view" }
const _hoisted_25 = { class: "list-group-flush" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item list-group-item message-list-itemm nav-list-header calls-list-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center h-100" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold mb-0 ms-2 text-app-secondary" }, "Calls")
  ])
], -1 /* HOISTED */)
const _hoisted_27 = { class: "search-input p-3 bg-white" }
const _hoisted_28 = {
  key: 0,
  class: "call-list col px-0 h-100 overflow-auto"
}
const _hoisted_29 = {
  key: 1,
  class: "col px-0 h-100 overflow-auto"
}
const _hoisted_30 = {
  key: 2,
  class: "col px-0 h-100 overflow-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConversationNav = _resolveComponent("ConversationNav")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CallSearch = _resolveComponent("CallSearch")!
  const _component_CallHistory = _resolveComponent("CallHistory")!
  const _component_MeetingCalendar = _resolveComponent("MeetingCalendar")!
  const _component_FamilyPortal = _resolveComponent("FamilyPortal")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_PageLayout, {
      "has-title": false,
      "content-class": "p-0"
    }, {
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("nav", {
            class: _normalizeClass(["chat-nav-list px-0", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
          }, [
            _createElementVNode("ul", _hoisted_3, [
              _createCommentVNode(" <li style=\"height: 3.5rem\" class=\"nav-item list-group-item\" @click=\"toggleAgencyNav\">\r\n                                <div class=\"d-flex flex-column align-items-center h-100\">\r\n                                    <img v-show=\"agencyNavOpened\" src=\"../../assets/images/chat/drawer-collapse.svg\" />\r\n                                    <img v-show=\"!agencyNavOpened\" src=\"../../assets/images/chat/drawer-expand.svg\" />\r\n                                </div>\r\n                            </li> "),
              _createCommentVNode(" <li\r\n                                class=\"nav-item list-group-item\"\r\n                                :class=\"{ 'active-tab': activeChatNav === ChatNavOptionsEnum.Profile }\"\r\n                                @click=\"chatNavSelected(ChatNavOptionsEnum.Profile)\"\r\n                            >\r\n                                <div class=\"d-flex flex-column align-items-center h-100\">\r\n                                    <i class=\"far fa-user\"></i>\r\n                                    <span> Profile</span>\r\n                                </div>\r\n                            </li> "),
              _createElementVNode("li", {
                style: {"height":"4rem"},
                class: _normalizeClass(["nav-item list-group-item", { 'active-tab': _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Chat }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chatNavSelected(_ctx.ChatNavOptionsEnum.Chat)))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_5, null, 512 /* NEED_PATCH */), [
                      [_vShow, _ctx.activeChatNav !== _ctx.ChatNavOptionsEnum.Chat]
                    ]),
                    _withDirectives(_createElementVNode("img", _hoisted_6, null, 512 /* NEED_PATCH */), [
                      [_vShow, _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Chat]
                    ]),
                    _createElementVNode("sup", _hoisted_7, [
                      (_ctx.unreadConvIds?.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.unreadConvIds.length), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _hoisted_9
                ])
              ], 2 /* CLASS */),
              _createElementVNode("li", {
                style: {"height":"4rem"},
                class: _normalizeClass(["nav-item list-group-item", { 'active-tab': _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Call }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chatNavSelected(_ctx.ChatNavOptionsEnum.Call)))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("img", _hoisted_11, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.activeChatNav !== _ctx.ChatNavOptionsEnum.Call]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_12, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Call]
                  ]),
                  _hoisted_13
                ])
              ], 2 /* CLASS */),
              (_ctx.hasTestAgency)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    style: {"height":"4rem"},
                    class: _normalizeClass(["nav-item list-group-item", { 'active-tab': _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Calendar }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chatNavSelected(_ctx.ChatNavOptionsEnum.Calendar)))
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("img", _hoisted_15, null, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.activeChatNav !== _ctx.ChatNavOptionsEnum.Calendar]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_16, null, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Calendar]
                      ]),
                      _hoisted_17
                    ])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (_ctx.hasFamilyPortalPermission)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    style: {"height":"6rem"},
                    class: _normalizeClass(["nav-item list-group-item", { 'active-tab': _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.FamilyPortal }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chatNavSelected(_ctx.ChatNavOptionsEnum.FamilyPortal)))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, [
                        _withDirectives(_createElementVNode("img", _hoisted_19, null, 512 /* NEED_PATCH */), [
                          [_vShow, _ctx.activeChatNav !== _ctx.ChatNavOptionsEnum.FamilyPortal]
                        ]),
                        _withDirectives(_createElementVNode("img", _hoisted_20, null, 512 /* NEED_PATCH */), [
                          [_vShow, _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.FamilyPortal]
                        ]),
                        _createElementVNode("sup", _hoisted_21, [
                          (_ctx.totalUnreadThreadCount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.totalUnreadThreadCount), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _hoisted_23
                    ])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ])
          ], 2 /* CLASS */),
          _withDirectives(_createElementVNode("nav", {
            class: _normalizeClass(["message-list overflow-auto", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
          }, [
            _createVNode(_component_ScrollPagination, {
              class: "content-y h-100 d-flex flex-column",
              "page-number": _ctx.convPagination.currentPage,
              "all-pages-loaded": _ctx.allPagesLoaded,
              "is-loading": _ctx.isLoading,
              "has-error": _ctx.hasError,
              onPageNumberUpdate: _ctx.pageNumberUpdated
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ConversationNav, {
                  "is-loading": _ctx.isLoading,
                  "page-number": _ctx.convPagination.currentPage,
                  "new-conversation": _ctx.newConversation,
                  onTermChanged: _ctx.updateChatSearchTerm,
                  onSortByChanged: _ctx.updateSortBy
                }, null, 8 /* PROPS */, ["is-loading", "page-number", "new-conversation", "onTermChanged", "onSortByChanged"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"])
          ], 2 /* CLASS */), [
            [_vShow, 
                            (!_ctx.isMobile || !_ctx.hideNav || (!_ctx.newConversation && _ctx.isMobile)) &&
                            _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Chat
                        ]
          ]),
          _withDirectives(_createElementVNode("section", _hoisted_24, [
            _createVNode(_component_router_view)
          ], 512 /* NEED_PATCH */), [
            [_vShow, 
                            (!_ctx.isMobile || (_ctx.isMobile && _ctx.newConversation)) && _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Chat
                        ]
          ]),
          _withDirectives(_createElementVNode("nav", {
            class: _normalizeClass(["message-list overflow-auto", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
          }, [
            _createElementVNode("ul", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("li", _hoisted_27, [
                _createVNode(_component_CallSearch)
              ])
            ])
          ], 2 /* CLASS */), [
            [_vShow, (!_ctx.isMobile || !_ctx.hideNav) && _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Call]
          ]),
          (_ctx.hideNav && _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Call)
            ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                _createVNode(_component_CallHistory)
              ]))
            : _createCommentVNode("v-if", true),
          ((!_ctx.isMobile || _ctx.hideNav) && _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.Calendar)
            ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                _createVNode(_component_MeetingCalendar)
              ]))
            : _createCommentVNode("v-if", true),
          ((!_ctx.isMobile || _ctx.hideNav) && _ctx.activeChatNav === _ctx.ChatNavOptionsEnum.FamilyPortal)
            ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                _createVNode(_component_FamilyPortal)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}